import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  paymentTermName: Yup.string().required(),
  paymentTermDays: Yup.number().positive().integer().required(),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
